import { render, staticRenderFns } from "./settings-fee-schedule-settings.vue?vue&type=template&id=573e1840&"
import script from "./settings-fee-schedule-settings.vue?vue&type=script&lang=js&"
export * from "./settings-fee-schedule-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('573e1840')) {
      api.createRecord('573e1840', component.options)
    } else {
      api.reload('573e1840', component.options)
    }
    module.hot.accept("./settings-fee-schedule-settings.vue?vue&type=template&id=573e1840&", function () {
      api.rerender('573e1840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/settings/settings-fee-schedule-settings.vue"
export default component.exports